import { useEffect } from "react";
import { getClients, getDriveModes, getModels, getSellerDevicesInStock } from "../../../APIs";
import { MODEL_COLORS, DATASET_COLORS } from "../../../Assets/styles/colors";
import { DATE_OPTIONS, DATE_RANGES, DEFAULT_DATE, DEV_TYPE_VALUES, ANALYTICS_DASHBOARD_ACC_CODE, SELLER_DES } from "../../../Library/constants";
import { getItemFromLocalStorage } from "../../../Library/helpers";

const useInitStore = (setConstants, setFilters, setIsLoading, setUserVehicles, setLtLastSeenData, setDrivers) => {
  const accessCodes = getItemFromLocalStorage("accessCodes") || [];
  const DESIGNATION = getItemFromLocalStorage("des");

  useEffect(() => {
    const handleBikes = (bikesAndLastSeen) => {
      setUserVehicles(bikesAndLastSeen.bikes?.length ? bikesAndLastSeen.bikes.filter(bike => bike.did) : []);
      setLtLastSeenData(bikesAndLastSeen.lastseen?.length ? bikesAndLastSeen.lastseen : []);
      if(bikesAndLastSeen.drivers) setDrivers(bikesAndLastSeen.drivers);
    }

    const listenForUserVehicles = () => {
      global.EE.addEventListener(global.EE.EVENT_TYPES.ON_BIKES, handleBikes);
    }

    const fetchStoreData = async () => {
      try {
        const modelData = (accessCodes && accessCodes.length && accessCodes.includes(ANALYTICS_DASHBOARD_ACC_CODE)) ? await getModels() : [];
        const modelMap = {};
        modelData.forEach((model, i) => {
          modelMap[model.idx] = { ...model, color: MODEL_COLORS[i % MODEL_COLORS.length] };
        });
  
        // Setting Default Model and Range Filters
        const models = modelData.map((model) => model.idx);
        let range = DEFAULT_DATE;
  
        const searchParams = new URLSearchParams(window.location.search);
        const searchRange = Number(searchParams.get("range"));
        if (searchRange) {
          if (searchRange === DATE_OPTIONS.CUSTOM) {
            const fromRange = Number(searchParams.get("from"));
            const toRange = Number(searchParams.get("to"));
  
            if (fromRange && toRange) {
              DATE_RANGES[DATE_OPTIONS.CUSTOM].from = fromRange;
              DATE_RANGES[DATE_OPTIONS.CUSTOM].to = toRange;
  
              range = searchRange;
            }
          } else if (DATE_RANGES[searchRange]) {
            range = searchRange;
          }
        }
  
        const driveModes = await getDriveModes();
        driveModes.push({ idx: 0, label: "All Modes" })
        const driveModeMap = {};
        driveModes.forEach((mode) => {
          driveModeMap[mode.idx] = { ...mode, graph: true, color: DATASET_COLORS.BRANDY };
        });
  
        let clientData = [];
        let clientMap;
        let client;
  
        if (!accessCodes || !accessCodes.length) {
          clientData = await getClients();
          clientMap = {};
  
          if(!clientData || !clientData.length){
            clientData = []
          }
          else{
            clientData.forEach((client) => {
              clientMap[client.idx] = { ...client };
            });
            // Setting first client as default
            client = clientData[0].idx;
          }
        }
  
        let clientName = window.location.hostname.split(".");
        if (clientName && clientName.length) clientName = clientName[0];
  
        let walletData;
        walletData = DESIGNATION === SELLER_DES ? await getSellerDevicesInStock() : { walletStock: {} };
        let count = 0;
        if (walletData && walletData.walletStock) {
          if (walletData.walletStock[DEV_TYPE_VALUES["Ajjas"]]) count += (walletData.walletStock[DEV_TYPE_VALUES["Ajjas"]] || 0);
          if (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (500 mAh Battery)"]]) count += (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (500 mAh Battery)"]] || 0);
          if (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (1200 mAh Battery) Regular Harness"]]) count += (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (1200 mAh Battery) Regular Harness"]] || 0);
          if (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (1200 mAh Battery) Lectrix Harness"]]) count += (walletData.walletStock[DEV_TYPE_VALUES["Ajjas (1200 mAh Battery) Lectrix Harness"]] || 0);
        }
  
        setConstants({ name: clientName, wallet: { count: count, batWiseCount: walletData.walletStock, total: walletData.totalDev }, models: modelData, modelMap: modelMap, driveModeMap: driveModeMap, clients: clientData, clientMap: clientMap, });
        setFilters({ models, range, client });
  
        setIsLoading(false);
      } catch(e) {
        console.error("Error in Init!", e);
      }
    };

    fetchStoreData();
    global.EE.addEventListener(global.EE.EVENT_TYPES.UWS_CONNECTED, listenForUserVehicles);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.UWS_CONNECTED, listenForUserVehicles);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_BIKES, handleBikes);
    }
  }, [setConstants, setFilters, setIsLoading]);
};

export default useInitStore;